/**
 * Returns a slug string from the org level values that come after org_level_after_location.
 * e.g. if org_level_after_location=2 and levels 3/4/5 are 'foo','bar','baz', returns 'FOO-BAR-BAZ'
 */
export function makePositionSlug(org_level_after_location, org_level_1_value, org_level_2_value, org_level_3_value, org_level_4_value, org_level_5_value) {
    const values = [org_level_1_value, org_level_2_value, org_level_3_value, org_level_4_value, org_level_5_value]
    return values
        .slice(org_level_after_location - 1)
        .filter(v => v != null && v !== '')
        .join('-')
        .toUpperCase()
}
